module.exports = __webpack_public_path__ + "img/16.942bf804.gif";